import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreLoginModule } from './pre-login/pre-login.module';
import { PostLoginModule } from './post-login/post-login.module';
import { BasicLayoutModule } from './basic-layout/basic-layout.module';
import { CookieService } from 'ngx-cookie-service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../environments/environment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // , NgbNavModule
import { HaloToastComponent } from './core/halo-toast/halo-toast.component';
import { HaloLoaderComponent } from './core/halo-loader/halo-loader.component';
import { HaloModalComponent } from './core/halo-modal/halo-modal';
import { NotificationComponent } from './core/notification/notification';
import { HaloTipsComponent } from './core/halo-tips/halo-tips.component';
import { AppHttpInterceptor } from './app.httpInterceptor';
import { AmplitudeAnalyticsService } from './core/services/amplitude-analytics.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.translationsPath, '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HaloToastComponent,
    HaloLoaderComponent,
    HaloModalComponent,
    NotificationComponent,
    HaloTipsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PreLoginModule,
    PostLoginModule,
    BasicLayoutModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    // NgbNavModule,
  ],
  providers: [CookieService, Title, AmplitudeAnalyticsService,{ provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule {}
